import { TabLayout, TabDescription } from '../TabLayout';
import { PerspectivesGroups } from './PerspectivesGroups';
import type { I18nLocale } from '@ardoq/i18n';

import {
  GetInvalidGroupingSelectOptions,
  GetRuleNotificationParams,
  PerspectiveGroupingRule,
  PerspectivesGroupsOptions,
  NotificationData,
  GetGroupDisabledProps,
} from '@ardoq/perspectives';

export type GroupsTabProps = {
  groupingOptions: PerspectivesGroupsOptions;
  groupingRules: PerspectiveGroupingRule[];
  getRuleNotificationParams?: GetRuleNotificationParams;
  onGroupingRuleReordered: (
    reorderedGroupingRules: PerspectiveGroupingRule[]
  ) => void;
  onGroupingRuleDeleted: (groupingRuleId: string) => void;
  onGroupingRuleAdded: (newGroupingRule: PerspectiveGroupingRule) => void;
  onGroupingRuleUpdated: (
    groupingRuleId: string,
    updatedGroupingRule: Partial<PerspectiveGroupingRule>
  ) => void;
  getInvalidGroupingSelectOptions?: GetInvalidGroupingSelectOptions;
  tabDescription: TabDescription;
  restrictedGroupFormattingWarningProps?: NotificationData;
  disableAddPerspectiveGroupButton?: boolean;
  getGroupDisabledProps?: GetGroupDisabledProps;
  /**
   * Whether the "By Reference Type Name" grouping should be available.
   * Wire to the consuming app's `Features.GROUPING_BY_TYPE_NAMES` flag.
   */
  isGroupingByTypeNamesEnabled?: boolean;
  i18nLocale: I18nLocale;
};

export const GroupsTab = ({ tabDescription, ...props }: GroupsTabProps) => {
  const sections = [
    {
      key: 'groups',
      ...tabDescription,
      content: <PerspectivesGroups {...props} />,
    },
  ];

  return <TabLayout sections={sections} />;
};
